module.exports = __webpack_public_path__ + "static/media/vision-03.7b92b5b1.jpg";